import { render, staticRenderFns } from "./NsTopnavProductHighlight.vue?vue&type=template&id=4de5e454&scoped=true&"
import script from "./NsTopnavProductHighlight.vue?vue&type=script&lang=js&"
export * from "./NsTopnavProductHighlight.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavProductHighlight.vue?vue&type=style&index=0&id=4de5e454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5e454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de5e454')) {
      api.createRecord('4de5e454', component.options)
    } else {
      api.reload('4de5e454', component.options)
    }
    module.hot.accept("./NsTopnavProductHighlight.vue?vue&type=template&id=4de5e454&scoped=true&", function () {
      api.rerender('4de5e454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavProductHighlight.vue"
export default component.exports